
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.041.744c.302 0 .546.244.546.545v1.438h1.438a.545.545 0 010 1.091H1.04a.545.545 0 01-.545-.545V1.289c0-.301.244-.545.545-.545z","fill":"#333"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.803 2.999A6 6 0 110 6a.545.545 0 111.09 0 4.91 4.91 0 10.658-2.455A.545.545 0 11.803 3z","fill":"#333"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.001 2.182c.302 0 .546.244.546.545v3.05l2.152 2.152a.545.545 0 01-.771.772L5.615 6.388a.545.545 0 01-.16-.386V2.727c0-.301.245-.545.546-.545z","fill":"#333"}})])
          )
        }
      }
    